import { AuthType, UserRoles } from '../api';
import * as TradingView from '../charting_library'
import { GeneralConfig } from "./general-config";
import { Entity, LanguageType, NamedEntity } from './misc';
import { SmpaConfig } from "./smpa";
import { TradingViewConfig } from "./tv-config";

export enum Repetition {
    Once,
    Repetitive,
    Lifetime
}
export enum DurationType {
    Daily,
    Weekly,
    Monthly
}
export interface UserPlan extends NamedEntity {
    tickers: number;
    setups: number;

    tickersBatch: number;
    tickersPerBatch: number;

    setupsBatch: number;
    setupsPerBatch: number;

    durationPrice: number;
    active: boolean;
    duration: number;
    durationType: DurationType;

    repetition: Repetition;
    userId?: number;
    group: number;
}


export interface UserSubscription extends Entity {
    uId: number;
    value: number;
    expiresAt: number;
    type: SubscriptionType;
    flgs: SubscriptionFlgs;
}

export enum SubscriptionFlgs {
    None,
    Canceled = 1,
    StickToPlan = 2
}
export enum SubscriptionType {
    Tickers,
    Setups
}

export enum PaymentServiceType {
    CryptoCloud,
    AmbWalletUsdt,
    AmbWalletUsd,
    StripeUsd,
    StripeEur
}

export interface SubscriptionsPaymentMethod {
    amount: number;
    svc: PaymentServiceType;
    comission: number;
    fee: number;
}
export interface SubscriptionPayment {
    id: number;
    type: SubscriptionType;
    flgs: SubscriptionFlgs;
    quantity: number;
    periods?: number;
}
export interface SubscriptionsPayment {
    planId: number;
    periods?: number;
    lang: LanguageType;
    svc?: PaymentServiceType;
    subs: SubscriptionPayment[];
}
export interface SubscriptionsPaymentInvoice {
    url: string;
    key?: string;
    orderId: number;
}
